import { Toast as TamaguiToast, useToastState } from '@tamagui/toast';
import * as React from 'react';
import { isWeb, XStack, YStack } from 'tamagui';

import { isNonMobileWeb } from '../../constants';
import { Shadows } from '../Shadows';
import { BodyMediumEmphasized, LabelRegular } from '../text/Typography';

export const Toast = () => {
    const toast = useToastState();

    if (!toast || toast.isHandledNatively) {
        return null;
    }

    const { id, duration, title, icon, button, description } = toast;

    return (
        <TamaguiToast
            key={id}
            duration={duration}
            animation="slow"
            enterStyle={{ x: -20, opacity: 0 }}
            exitStyle={{ x: -20, opacity: 0 }}
            opacity={1}
            width={isWeb ? '90vw' : '90%'}
            $sm={{ width: 480 }}
            minHeight={60}
            backgroundColor="$white"
            borderRadius={24}
            padding={12}
            justifyContent="center"
            borderWidth={1}
            borderColor="$gray400"
            {...(isNonMobileWeb ? Shadows.LARGE : Shadows.MEDIUM)}
        >
            <XStack
                justifyContent="space-between"
                alignItems="center"
                width="100%"
                height="100%"
                gap={8}
            >
                <XStack gap={12} alignItems="center" flex={1}>
                    {icon}
                    <YStack
                        paddingLeft={icon == null ? 12 : 0}
                        gap={4}
                        // Note: these maxWidths are based on the assumptions that
                        // (1) there is an icon, and (2) there is not a button
                        // because we expect most Toasts to have icons, and having a button is rare
                        // If we want, we could sort of calculate these values, but doing so confidently would
                        // require a rigid icon width and use of variables for toast width and padding/spacing
                        // (Screen width * .9) - 24 padding - ~50 icon width - 12 gap
                        $mobile_mini={{ maxWidth: 250 }}
                        $mobile_norm={{ maxWidth: 270 }}
                        $mobile_plus={{ maxWidth: 285 }}
                        $sm={{ maxWidth: 400 }}
                        height="100%"
                    >
                        <TamaguiToast.Title>
                            <BodyMediumEmphasized
                                numberOfLines={2}
                                lineHeight={20}
                            >
                                {title}
                            </BodyMediumEmphasized>
                        </TamaguiToast.Title>
                        {description != null && (
                            <LabelRegular numberOfLines={2}>
                                {description}
                            </LabelRegular>
                        )}
                    </YStack>
                </XStack>
                {button}
            </XStack>
        </TamaguiToast>
    );
};
